import React from 'react';

import { CompanySelectModel } from 'api/adminApiClient';
import { ClientFilterTypes } from 'features/client/enums';
import { ClientsFilters } from 'features/client/ClientsFilter';
import { AssignmentFilterTypes } from 'features/assignment/enums';
import { AssignmentFilters } from 'features/assignment/AssignmentsFilter';
import { ContractorCompanyFilterTypes } from 'features/admin/contractorCompany/enums';
import { ContractorCompanyFilters } from 'features/admin/contractorCompany/AdminContractorCompaniesSection/ContractorCompanyFilter';
import SelectWithLoading from 'hocs/withLoading/SelectWithLoading';

type Filters = ClientsFilters | AssignmentFilters | ContractorCompanyFilters;
type FilterTypes =
  | ClientFilterTypes
  | AssignmentFilterTypes
  | ContractorCompanyFilterTypes;

type Props = {
  filters: Filters;
  onChange: (data: Filters) => void;
  companies: CompanySelectModel[];
  isCompaniesLoaded: boolean;
};

export default function CompanyFilter(props: Props) {
  const { filters, companies, onChange, isCompaniesLoaded } = props;

  const handleFilterChange = (type: FilterTypes) => (value: string[]) => {
    onChange({
      ...filters,
      [type]: value,
    });
  };

  return (
    <SelectWithLoading
      isLoading={!isCompaniesLoaded}
      className="full-width"
      value={filters[ClientFilterTypes.Company]}
      mode="multiple"
      optionFilterProp="children"
      placeholder="Select member"
      onChange={handleFilterChange(ClientFilterTypes.Company)}
      showSearch
    >
      {companies.map(({ companyId, companyName }) => (
        <SelectWithLoading.Option key={companyId} value={companyId || ''}>
          {companyName}
        </SelectWithLoading.Option>
      ))}
    </SelectWithLoading>
  );
}
